import React, { Component } from 'react';
import {connect} from "react-redux";
import FullReportTopWordsComponent from "./full-report-top-words-component";
import {loadTopWordsRequest} from "../charts/charts-action-creators";
import {changePage, searchChange} from "./full-report-top-words-action-creators";



class FullReportTopWordsContainer extends Component {

  componentDidMount() {
    const { topWords, loadTopWords } = this.props;
    !topWords.length ? loadTopWords() : null;
  }

  render() {
    const columns = [
      {
        name: 'term',
        displayName: 'Term',
        width: '33.333333333333333%',
      },
      {
        name: 'count',
        displayName: 'Count',
        width: '33.333333333333333%',
      },
      {
        name: 'percent',
        displayName: 'Percent',
        width: '33.333333333333333%',
      }
    ];
    const { topWordsLoading } = this.props;
    return <FullReportTopWordsComponent
      columns={columns}
      loading={topWordsLoading}
      {...this.props}
    />
  }
}



const mapStateToProps = state => ({
  topWords: state.charts.topWords,
  topWordsPaginated: state.fullReportTopWords.topWordsPaginated,
  page: state.fullReportTopWords.page,
  topWordsLoading: state.charts.topWordsLoading,
  searchValue: state.fullReportTopWords.searchValue,
  reportUrl: state.report.reportUrl
});

const mapDispatchToProps = dispatch => ({
  loadTopWords: () => dispatch(loadTopWordsRequest()),
  changePage: ({next, previous}) => dispatch(changePage({next, previous})),
  searchChange: searchValue => dispatch(searchChange(searchValue))
});

export default connect(mapStateToProps, mapDispatchToProps)(FullReportTopWordsContainer);


// WEBPACK FOOTER //
// ./src/modules/full-report-top-words/full-report-top-words-container.js